import { useContext, useEffect } from "react";
import { AppContext } from "../App";
import { t } from "../i18n";
import { prefixes } from "../utils/symbols";

export default function PhoneLabel({ isRequired = false }) {
	const { data, setData, errors, flow } = useContext(AppContext);

	const selectedPrefix =
		prefixes.find((p) => p.code === (data.prefixCode || "+34")) ||
		prefixes.find((p) => p.code === "+34");

	const handlePrefixChange = (e) => {
		const value = e.target.value;

		setData((prev) => ({
			...prev,
			prefixCode: value,
		}));
	};

	const handlePhoneChange = (e) => {
		const value = e.target.value;

		setData((prev) => ({
			...prev,
			shortPhone: value,
		}));
	};

	useEffect(() => {
		if (flow === "mapfre") return;

		setData((prev) => ({
			...prev,
			phone: `${prev.prefixCode || "+34"}${prev.shortPhone || ""}`,
		}));
	}, [data.prefixCode, data.shortPhone, setData, flow]);

	return (
		<label>
			<strong>
				{t("Teléfono")}{" "}
				{isRequired && <span className="required">*</span>}
			</strong>
			<div className="phone-input">
				{flow !== "mapfre" && (
					<div className="custom-select">
						<div className="select">
							<span>{selectedPrefix.flag}</span>
							<span>{selectedPrefix.code}</span>
						</div>
						<select
							value={data.prefixCode || "+34"}
							onChange={handlePrefixChange}
						>
							{prefixes.map((p) => (
								<option key={p.code} value={p.code}>
									{`${p.flag} (${p.code}) ${p.country}`}
								</option>
							))}
						</select>
					</div>
				)}

				<input
					type="tel"
					value={data.shortPhone || ""}
					onChange={handlePhoneChange}
				/>
			</div>
			{errors.phone && <span className="error">{errors.phone}</span>}
		</label>
	);
}
